#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

mutation PayCycleEmailCreate($input: PayCycleEmailCreateInput!) {
  payCycleEmailCreate(input: $input) {
    payCycleEmail {
      _emailDocument {
        ...EmailDocumentFields
      }
      emailDocumentsByEntityId(orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]) {
        nodes {
          ...EntityEmailDocumentsFields
        }
      }
    }
  }
}
